import { inputAndDiscussPinPhases, SortingQuestionView } from '../../playerStore.types';
import { PlayerPinReducer, PlayerPinReducerFactory } from '../reducers.types';
import { nextPhase } from '../reducers.utils';

export type SortingQuestionReducer = PlayerPinReducer<SortingQuestionView>;

export const createSortingQuestionReducer: PlayerPinReducerFactory<SortingQuestionView> = () => sortingQuestionReducer;

export const sortingQuestionReducer: SortingQuestionReducer = {
  phases: inputAndDiscussPinPhases,
  initial: () => {
    return {
      type: 'SORTING_QUESTION',
      phase: 'input',
    };
  },
  hasNextView: (state, currentView, direction) => {
    return nextPhase(currentView.phase, sortingQuestionReducer.phases, direction) !== null;
  },
  handleNextView: (state, prev, direction) => {
    if (!prev) {
      return false;
    }

    const next = nextPhase(prev.phase, sortingQuestionReducer.phases, direction);
    if (next) {
      return {
        type: 'SORTING_QUESTION',
        phase: next,
      };
    }
    return false;
  },
  onNextView: async (state, prev, next, services, setBackgroundActionAction) => {
    if (prev.phase === 'input') {
      const action = () => services.apiService.sortingQuestion.checkPinStudentAnswers(state.currentPinId);
      setBackgroundActionAction?.(action);
      return action();
    }
    return null;
  },
};
